/* eslint-disable max-len */
import React, { useCallback, useEffect } from "react";
import { Input } from "antd";
import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";
import { css } from "styled-components";

// LIBRARY USED: https://www.npmjs.com/package/intl-tel-input
// Referring to yichang's sandbox: https://codesandbox.io/s/react-antd-intl-tel-input-8z6b2t

export const DialCodeInputStyles = css`
    /* Required for  */
    .iti__flag {background-image: url("https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/img/flags.png");}

    /* stylelint-disable-next-line media-feature-name-no-vendor-prefix */
    @media (-webkit-min-device-pixel-ratio: 2), (resolution >= 192dpi) {
        .iti__flag {background-image: url("https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/img/flags@2x.png");}
    }

    /* Override Styles */
    /* .bukku-intl-phone-input-wrapper {
        padding: 0;
        border: 0;

        .ant-input-suffix {
            position: absolute;
            top: 50%;
            right: 0%;
            bottom: 50%;
            margin-right: 8px;
        }

        .bukku-intl-phone-input {
            width: 100%;

                .iti__flag-container {
                .iti__selected-flag {}

                .iti__country-list {
                    width: 330px;
                    overflow-x: hidden;
    
                    .iti__country {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;

                        .iti__country-name {
                            flex: 1 0 200px;
                            overflow-x: hidden;
                            text-overflow: ellipsis;
                        }

                        .iti__dial-code {
                            flex: 1 0 70px;
                            padding-right: 5px;
                            text-align: end;
                        }
                    }
                }
            }
        }
    } */

    .bukku-intl-phone-input-wrapper {
        position: relative;
        padding: 0;
        border: 0;
        
        --dropdown-top-distance: 30px;

        &:has(.ant-input-lg) {
            --dropdown-top-distance: 40px; 
        }

        .ant-input-suffix {
            position: absolute;
            top: 50%;
            right: 0%;
            bottom: 50%;
            margin-right: 8px;
        }

        .bukku-intl-phone-input {
            width: 100%;
        }

        .iti--container {
            position: absolute;
            top: var(--dropdown-top-distance) !important;
            left: 0 !important; 
            width: 100%;

            .iti__country-list {
                width: 100%;
                overflow-x: hidden;

                .iti__country {
                    display: flex;
                    align-items: center;

                    .iti__country-name {
                        flex: 1 0 65%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        text-wrap: nowrap;
                    }

                    .iti__dial-code {
                        flex: 0 1 60px;
                        text-align: end;
                    }
                }
            }
        }
    }
`;
export function DialCodeInput(props) {
    // Using the data (list) without input
    // const countryData = window.intlTelInputGlobals.getCountryData();
    // console.log('aaa countryData', countryData);

    const {value, defaultFormValue, intlRef, onBlur: parentOnBlur, size} = props;
    // initialize with intl-tel-input
    // const intlRef = useRef();

    const setValue = useCallback(value => {
        intlRef.current.setNumber(value);
    }, [intlRef]);

    useEffect(() => {
        const input = document.getElementById("phone-input");
        // console.log("aaa input", {input, props});

        // input.addEventListener("open:countrydropdown", e => {});

        if (input && intlRef) {
            intlRef.current = intlTelInput(input, {
                initialCountry: "my",
                preferredCountries: ["my", "sg", "id"],
                separateDialCode: true,
                nationalMode: false, // shows as '+6012...' instead of '012...'
                customContainer: 'bukku-intl-phone-input',
                formatOnDisplay: false, // shows as '+60123456789'  instead of '+6012-345 6789'
                dropdownContainer: document.querySelector(".bukku-intl-phone-input-wrapper"),
                utilsScript:
                "https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.3/build/js/utils.js",
            //   "intl-tel-input/build/js/utils.js",
            });
        }
    }, [intlRef]);

    // set initial value
    useEffect(() => {
        // console.log('aaa useEffect value', {value});
        if (value)
            setValue(value);
    }, [value, setValue, intlRef]);

    // const onInputBlur = e => {
    //     const {value} = e.target;
    //     console.log('aaa value', value);
    //     e.preventDefault();
    //     e.stopPropagation();
    //     onBlur(e);
    // };

    // accept numbers only
    const onKeyDown = e => {
        const exceptThisSymbols = ["e", "E", "+", "-", "."];
        if (exceptThisSymbols.includes(e.key))
            e.preventDefault();
    };

    const onBlur = () => {
        if (parentOnBlur) {
            const phoneNumber = intlRef.current.getNumber();
            return parentOnBlur(phoneNumber);
        }
        return undefined;
    };

    console.log('aaa render DialCodeInput');

    return (
        <>
            <Input
                id="phone-input"
                className="bukku-intl-phone-input-wrapper"
                // onBlur={onInputBlur}
                defaultValue={defaultFormValue}
                allowClear
                type="number"
                onKeyDown={onKeyDown}
                onBlur={onBlur}
                size={size}
            />
            {/* <Button onClick={setValue}>Set Value</Button> */}
        </>

    );
}
